import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { useAuth, AuthUser } from '../lib/auth';

type MagicResult = { token: string; user: AuthUser };

export default function MagicLogin() {
  const [params] = useSearchParams();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setMessage('No sign-in token found in the link.');
      return;
    }

    api.get<MagicResult>(`/auth/magic-login?token=${token}`)
      .then(res => {
        login(res.token, res.user);
        setStatus('success');
        setTimeout(() => navigate(res.user.role === 'admin' ? '/admin' : '/'), 1500);
      })
      .catch(err => {
        setStatus('error');
        setMessage(err.message ?? 'This link has expired or already been used.');
      });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: '#f4f4f4' }}>
      <div className="w-full max-w-sm text-center">

        {status === 'loading' && (
          <>
            <div className="w-12 h-12 rounded-full border-4 border-gray-200 mx-auto mb-4"
              style={{ borderTopColor: '#e00000', animation: 'spin 0.8s linear infinite' }} />
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            <p style={{ color: '#8f9b9b' }}>Signing you in…</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
              style={{ background: '#f0fdf4', border: '2px solid #86efac' }}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </div>
            <h1 className="text-xl font-bold mb-2" style={{ color: '#0b0d0e' }}>Signed in!</h1>
            <p style={{ color: '#8f9b9b', fontSize: 14 }}>Taking you to your dashboard…</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
              style={{ background: '#fff0f0', border: '2px solid #fca5a5' }}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#e00000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="9"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
            </div>
            <h1 className="text-xl font-bold mb-2" style={{ color: '#0b0d0e' }}>Link expired</h1>
            <p className="text-sm mb-6" style={{ color: '#8f9b9b' }}>{message}</p>
            <a href="/login" className="btn-primary">Back to sign in</a>
          </>
        )}
      </div>
    </div>
  );
}
